import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export default function ChatInput({ onSend, disabled, inputRef }) {
  const [text, setText] = React.useState('');

  const submit = () => {
    const t = text.trim();
    if (!t || disabled) return;
    onSend(t);
    setText('');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, p: 1, borderTop: '1px solid', borderColor: 'divider' }}>
      <TextField
        multiline
        maxRows={5}
        fullWidth
        size="small"
        placeholder="Ask about this report…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        inputRef={inputRef}
      />
      <IconButton
        color="primary"
        onClick={submit}
        disabled={disabled || !text.trim()}
        aria-label="Send"
        sx={{
          transition: 'box-shadow 200ms ease',
          '&:hover:not(.Mui-disabled)': {
            boxShadow: '0 0 14px 4px rgba(81,85,213,0.28)',
          },
        }}
      >
        <SendIcon />
      </IconButton>
    </Box>
  );
}
